import showcaseWide from '../assets/img/projects/design/showcase-wide.webp';
import showcaseTall from '../assets/img/projects/design/showcase-tall.webp';
import { getProject, type Project } from './projects';

export interface Showcase {
    project: Project;
    wideImage: string;
    tallImage: string;
    width: number;
    height: number;
}

export const showcase: Showcase = {
    project: getProject('design'),
    wideImage: showcaseWide,
    tallImage: showcaseTall,
    width: 2688,
    height: 1344
};
